import { object, string } from 'yup';

export const contactFormSchema = object().shape({
	full_name: string()
		.trim()
		.min(2, 'ContactUsId27')
		.max(100, 'ContactUsId27')
		.required('ContactUsId33'),
	email: string()
		.trim()
		.email('ContactUsId30')
		.max(254, 'ContactUsId29')
		.required('ContactUsId28'),
	message: string()
		.trim()
		.min(10, 'ContactUsId32')
		.max(2000, 'ContactUsId32')
		.required('ContactUsId31'),
});
